import { getColumns } from './schema';
import { getColumnWidth } from './schema';
import { React } from 'libs/react';
/**
 * @component TableColgroup
 * @since 1.0.0
 * @hidden
 */
export function TableColgroup(props) {
    const { schema } = props;
    const columns = getColumns(schema);
    return (React.createElement("colgroup", null, columns.map((column) => {
        const width = getColumnWidth(schema[column]);
        return React.createElement("col", { key: column, style: width ? { width } : undefined });
    })));
}
